<template>
  <div class="rain-level-detail px-2 py-1">
    <v-card class="caption text--secondary" flat height="20">
      {{ selectedObservatory.address }}
    </v-card>
    <v-card class="d-flex align-center" flat tile>
      <v-btn-toggle
        v-if="predictData.length > 0"
        v-model="displayHours"
        mandatory
        dense
        class="mr-3 mb-1"
      >
        <v-btn small :value="6" class="px-1">
          6時間予測
        </v-btn>
        <v-btn small :value="36" class="px-1">
          36時間予測
        </v-btn>
      </v-btn-toggle>
      <v-btn-toggle v-model="displayInterval" mandatory dense class="mb-1">
        <v-btn small :value="10" class="px-1">
          10分毎
        </v-btn>
        <v-btn small :value="60" class="px-1">
          時間毎
        </v-btn>
      </v-btn-toggle>
    </v-card>
    <div class="d-flex my-2" v-if="!isDeficit">
      <div class="caption">(mm/{{ displayInterval }}分)</div>
      <div class="caption ml-auto">(mm)</div>
    </div>
    <RainChart
      v-if="!isDeficit"
      :height="isMobile ? 200 : 240"
      :selected-observatory="selectedObservatory"
      :displayHours="displayHours"
      :displayInterval="displayInterval"
      :currentDate="currentDate"
    />
    <v-simple-table
      dense
      class="mt-2"
      fixed-header
      :height="isMobile ? 'calc(100dvh - 410px)' : 'calc(100dvh - 390px)'"
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">日時</th>
            <th class="text-left" v-if="displayInterval === 10">10分</th>
            <th class="text-left" v-if="displayInterval === 60">60分</th>
            <th class="text-left">累加</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(ts, i) in timeSeries"
            :key="i"
            :class="{ predict: ts.predict }"
            :id="`row-${i}`"
          >
            <td>{{ ts.time }}</td>
            <td v-if="displayInterval === 10">{{ ts.min10 }}</td>
            <td v-if="displayInterval === 60">{{ ts.min60 }}</td>
            <td>{{ ts.total }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="mt-5 caption" v-if="isDeficit">
      この観測所は欠測しています。
    </div>
  </div>
</template>

<script>
import RainChart from "./RainChart";
import moment from "moment";

export default {
  name: "RainDetail",
  components: { RainChart },
  data() {
    return {
      displayHours: 6,
      displayInterval: 10
    };
  },
  computed: {
    isMobile() {
      return this.$route.path === "/mobile";
    },
    currentDate() {
      const baseDate = this.$store.getters.baseDate.clone();
      return baseDate
        .subtract(baseDate.minute() % 10, "minutes")
        .format("YYYY/MM/DD HH:mm");
    },
    selectedObservatory() {
      return this.$store.getters.selectedObservatory;
    },
    mesuredData() {
      if (this.selectedObservatory.timeSeries === undefined) {
        return [];
      }
      return this.selectedObservatory.timeSeries.filter(v => v.type === "real");
    },
    predictData() {
      if (this.selectedObservatory.timeSeries === undefined) {
        return [];
      }
      return this.selectedObservatory.timeSeries.filter(
        v => v.type === "forecast"
      );
    },
    isDeficit() {
      return this.mesuredData.length == 0;
    },
    timeSeries() {
      const displayStartTime = moment
        .utc(this.selectedObservatory.baseDate, "YYYY/MM/DD HH:mm")
        .subtract(this.displayInterval === 10 ? 3 : 23, "hours")
        .format("YYYY/MM/DD HH:mm");
      const displayLimitTime = moment
        .utc(this.selectedObservatory.baseDate, "YYYY/MM/DD HH:mm")
        .add(this.displayHours, "hours")
        .format("YYYY/MM/DD HH:mm");
      return this.selectedObservatory.timeSeries
        .filter(
          r =>
            r.date > displayStartTime &&
            r.date <= displayLimitTime &&
            (this.displayInterval === 10 ||
              (this.displayInterval === 60 && r.date.substr(-2) === "00"))
        )
        .map(r => {
          const time = moment
            .utc(r.date, "YYYY/MM/DD HH:mm")
            .local()
            .format("MM/DD HH:mm");
          return {
            time: time,
            predict: r.type === "forecast",
            min10:
              r.min10 !== undefined ? parseFloat(r.min10).toFixed(2) : "---",
            min60:
              r.min60 !== undefined ? parseFloat(r.min60).toFixed(2) : "---",
            total:
              r.total !== undefined ? parseFloat(r.total).toFixed(2) : "---"
          };
        });
    }
  },
  watch: {
    selectedObservatory() {
      setTimeout(() => {
        this.scrollNow();
      }, 500);
    },
    timeSeries() {
      setTimeout(() => {
        this.scrollNow();
      }, 500);
    }
  },
  mounted() {
    setTimeout(() => {
      this.scrollNow();
    }, 500);
  },
  methods: {
    scrollNow() {
      const reals = this.timeSeries.filter(row => !row.predict);
      if (reals.length === 0) return;
      const targetIndex = reals.length - 1;
      if (targetIndex < 0) return;
      const id = `#row-${targetIndex}`;
      const height = this.$el.querySelector(id).clientHeight;
      const tableWrapper = this.$el.getElementsByClassName(
        "v-data-table__wrapper"
      )[0];
      const top = height * (targetIndex - (this.isMobile ? 3 : 5));
      tableWrapper.scroll({ top, behavior: "instant" });
    }
  }
};
</script>

<style lang="scss" scoped>
.rain-level-detail {
  thead {
    background-color: #addff3;
  }
  tbody td {
    background: #eee;
  }
  tbody tr:nth-child(odd) td {
    background: #fff;
  }
  .predict {
    color: blue;
  }
}
</style>
